import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const qp = new URLSearchParams(window.location.search).get('lang');
      if (qp && translations[qp]) {
        localStorage.setItem('partyledLang', qp);
        return qp;
      }
    } catch (e) { /* noop */ }
    return localStorage.getItem('partyledLang') || 'fr';
  });

  const t = translations[lang] || translations.fr;

  const switchLang = (newLang) => {
    if (translations[newLang]) {
      setLang(newLang);
      localStorage.setItem('partyledLang', newLang);
      document.documentElement.lang = newLang;
      document.documentElement.dir = translations[newLang].dir;
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('lang')) {
          url.searchParams.set('lang', newLang);
          window.history.replaceState({}, '', url);
        }
      } catch (e) { /* noop */ }
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = t.dir;
  }, [lang, t.dir]);

  return (
    <LanguageContext.Provider value={{ lang, t, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
